<template>
    <div class="store-order-status col-md-3" v-dusk="customerTypeSlug + '-order-status-' + customerId + '-' + id">
        <a v-if="counters.nb_ordered > 0" class="btn" :class="preparationBgClass(preparationStatus.color)" :href="'/espace-employes/commandes/preparation/commande/' + id">
            <StatusCircle
                v-if="preparationStatus.color_of_category"
                :color="preparationStatus.color_of_category"
            />
            <template v-if="customerType === 'short_channel' && !readyToPrepare">
                <NotReadyToPrepareIcon/>
            </template>
            <template v-if="counters.nb_missing > 0">
                <MissingProductsIcon></MissingProductsIcon>
            </template>
            <template v-if="hasComments">
                <HasCommentsIcon></HasCommentsIcon>
            </template>
            {{ name }}
            <template v-if="hasPriority">
                <HasPriority></HasPriority>
            </template>
            <div class="reference">
                {{ reference }} - {{ statusLabel }}
            </div>
        </a>
        <a v-else class="btn preparation-bg-gray" :href="newOrderUrl">
            {{ name }}
            <div class="reference">
                {{ reference }} - {{ statusLabel }}
            </div>
        </a>
        <div class="counter">
            <template v-if="preparationStatus.numerator || preparationStatus.denominator || counters.nb_toremove">
                {{ preparationStatus.numerator }} / {{ preparationStatus.denominator }}
                <small v-if="counters.nb_toremove > 0">
                    + {{ counters.nb_toremove }} à retirer
                </small>
                <small v-if="counters.nb_missing > 0">
                    - {{ counters.nb_missing }} manquant(s)
                </small>
            </template>
            <template v-else>
                Aucune commande
            </template>
        </div>
    </div>
</template>

<script>
    import HasCommentsIcon from "../HasCommentsIcon"
    import HasPriority from "../HasPriority"
    import MissingProductsIcon from "../MissingProductsIcon";
    import NotReadyToPrepareIcon from "../NotReadyToPrepareIcon";
    import StatusCircle from "./StatusCircle"
    import {preparationBgClass} from "../../../preparation-classes";

    export default {
        name: 'StoreOrderStatus',

        components: {
            HasCommentsIcon,
            HasPriority,
            MissingProductsIcon,
            NotReadyToPrepareIcon,
            StatusCircle,
        },

        props: {
            customerId: {
                type: Number,
                required: true,
            },
            customerType: {
                type: String,
                required: true,
            },
            endPreparationDate: {
                type: String,
                required: true,
            },
            id: {
                type: Number,
                required: true,
            },
            reference: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            statusLabel: {
                type: String,
                required: true,
            },
            preparationStatus: {
                type: Object,
                required: true,
            },
            hasComments: {
                type: Boolean,
                required: false,
                default: false,
            },
            hasPriority: {
                type: Boolean,
                required: false,
                default: false,
            },
            readyToPrepare: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            customerTypeSlug() {
                if (this.customerType === 'short_channel') {
                    return 'short-channel';
                }
                return 'store';
            },

            counters() {
                return this.preparationStatus.preparation_counters;
            },

            newOrderUrl() {
                if (this.customerType === 'short_channel') {
                    return '/espace-employes/commandes/commande-circuit-court/' + this.customerId + '/creation/' + this.endPreparationDate;
                } else if (this.customerType === 'store') {
                    return '/espace-employes/commandes/commande-magasin/' + this.customerId + '/creation/' + this.endPreparationDate;
                } else {
                    return '/espace-employes/commandes/nouvelle-commande/' + this.endPreparationDate;
                }
            },
        },

        methods: {
            preparationBgClass,
        },
    }
</script>

<style lang="scss" scoped>
    .store-order-status {
        & > a {
            position: relative;
        }

        a {
            text-decoration: none;
            color: #212529;
        }

        .btn {
            display: block;
            width: 100%;
            padding: 0.5rem 1rem;
            border: 2px solid #252525;
            border-radius: 3px;
            font-weight: bold;
            font-size: 1.2rem;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        }

        .counter {
            text-align: center;
            font-weight: bold;
            font-size: 1.2rem;
        }

        .reference {
            font-size: 70%;
        }
    }
</style>
